import { DatePickerProps } from "antd/lib/date-picker";
import { defaultDateFormats } from "common/DatePicker/defaultDateFormats";
import * as React from "react";
import { DatePicker as AntdDatePicker } from "antd";

export const DatePicker = React.forwardRef<React.Component, DatePickerProps>((props, ref) => {
  return <AntdDatePicker format={defaultDateFormats} ref={ref} {...props} />;
});
